<template>
	<div id="login" v-if="!systemLoading">
		<div class="login-wrapper">
			<form class="login-form" method="POST" v-on:submit.prevent="login">
				<div class="login-container">
					<div class="login-header">
						<Logo />
					</div>
					<div class="form-fields">
						<b-loading :is-full-page="false" :active="processing" />
						<h1 class="title is-4">Dashboard Login</h1>
						<b-notification
							type="is-danger"
							v-if="error"
							:closable="false">
							{{ error }}
						</b-notification>
						<b-field
							label="Email"
							:type="feedback.email.type"
							:message="feedback.email.message">
							<b-input v-model.trim="input.email"
							         ref="email"
							         type="email"
							         autofocus>
							</b-input>
						</b-field>
						<b-field label="Password"
						         :type="feedback.password.type"
						         :message="feedback.password.message">
							<b-input v-model="input.password"
							         type="password"
							         ref="password"
							         password-reveal>
							</b-input>
						</b-field>
						<div class="level options">
							<div class="checkbox level-left">
								<b-checkbox
									v-model="input.remember"
									name="remember">Remember me
								</b-checkbox>
							</div>

							<router-link
								to="forgot-password"
								class="level-right forgot-password"
							>Forgot Password?
							</router-link>
						</div>
					</div>
					<div class="login-footer">
						<button class="button is-primary has-icon"
						        :disabled="processing"
						        type="submit">
							<b-icon icon="sign-in-alt"></b-icon>
							<span class="button-label">Login</span>
						</button>
					</div>
				</div>
			</form>
			<p class="login-copyright">&copy; {{ new Date().getFullYear() }} &ndash; {{ title }}. All rights reserved.</p>
		</div>
	</div>
</template>

<script>
import Logo from './Icons/Logo'
import { AUTH_REQUEST } from '../store/actions/auth'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { INIT_STATUS } from '../store/actions/init'

export default {
  components: {
    Logo
  },
  data () {
    return {
      title: process.env.NAME,
      input: {
        email: '',
        password: '',
        remember: false
      },
      feedback: {
        'email': {
          'type': '',
          'message': ''
        },
        'password': {
          'type': '',
          'message': ''
        }
      },
      error: '',
      processing: false
    }
  },
  computed: {
    ...mapState({
      systemLoading: state => state.loading
    }),
    ...mapGetters({
      isAuthenticated: 'isAuthenticated'
    })
  },
  watch: {
    systemLoading: function (newVal, oldVal) {
      if (oldVal === false && newVal !== false) {
        if (this.$refs.email !== undefined) this.$refs.email.focus()
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ]),
    validateLogin () {
      this.error = ''
      this.feedback.email.type = ''
      this.feedback.email.message = ''
      this.feedback.password.type = ''

      if (this.input.email === '') {
        this.feedback.email.type = 'is-danger'
        this.feedback.email.message = 'Email cannot be blank'
        this.processing = false
        return false
      }

      if (!this.input.password) {
        this.feedback.password.type = 'is-danger'
        this.feedback.password.message = 'Password cannot be blank'
        this.processing = false
        return false
      }

      return true
    },
    login () {
      this.processing = true

      let notices = document.querySelectorAll('.notices')
      for (let n in notices) {
        if (!notices.hasOwnProperty(n)) continue
        notices[n].outerHTML = ''
      }

      let modals = document.querySelectorAll('.modal')
      for (let m in modals) {
        if (!modals.hasOwnProperty(m)) continue
        modals[m].outerHTML = ''
      }

      if (this.validateLogin()) {
        const { email, password, remember, ip } = this.input
        this.$store.dispatch(AUTH_REQUEST, { email, password, remember, ip }).then(response => {
          this.$awn.success(response.message)

          let targetRoute = { name: 'dashboard' }
          if (this.$route.query.r !== undefined) {
            targetRoute = this.$route.query.r
          }

          this.$router.push(targetRoute)
        }).catch(error => {
          this.processing = false

          if (error.hasOwnProperty('response')) {
            if (error.response.data.response === 'error') {
              this.error = error.response.data.message
              this.input.password = ''
              this.$refs.password.focus()
            }

            if (error.response.data.response === 'validationError') {
              let fields = error.response.data.data
              for (const prop in fields) {
                if (fields.hasOwnProperty(prop)) {
                  if (this.feedback.hasOwnProperty(prop)) {
                    this.feedback[prop].type = 'is-danger'
                    this.feedback[prop].message = fields[prop]
                  }
                }
              }
            }
          } else {
            this.$buefy.toast.open({
              message: error.toString(),
              type: 'is-danger'
            })
          }
        })
      }
    }
  },
  mounted () {
    if (this.$refs.email !== undefined) this.$refs.email.focus()

    this.setPageTitle('Login')
    this.$store.dispatch(INIT_STATUS)

    if (sessionStorage.getItem('email')) {
      this.input.email = sessionStorage.getItem('email')
    }
  }
}
</script>

<style>
.notices .snackbar ~ .snackbar {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue